export const airports = [
    { name: "London Heathrow", code: "LHR", id: 1 },
    { name: "London Gatwick", code: "LGW", id: 2 },
    { name: "Manchester", code: "MAN", id: 3 },
    { name: "London Stansted", code: "STN", id: 4 },
    { name: "London Luton", code: "LTN", id: 5 },
    { name: "Edinburgh", code: "EDI", id: 6 },
    { name: "Birmingham", code: "BHX", id: 7 },
    { name: "Bristol", code: "BRS", id: 8 },
    { name: "Glasgow Int.", code: "GLA", id: 9 },
    { name: "Belfast Int.", code: "BFS", id: 10 },
    { name: "Newcastle", code: "NCL", id: 11 },
    { name: "Liverpool", code: "LPL", id: 12 },
    { name: "Leeds Bradford", code: "LBA", id: 13 },
    { name: "East Midlands", code: "EMA", id: 14 },
    { name: "London City", code: "LCY", id: 15 },
    { name: "Aberdeen", code: "ABZ", id: 16 },
    { name: "Belfast City", code: "BHD", id: 17 },
    { name: "Jersey", code: "JER", id: 18 },
    { name: "Cardiff", code: "CWL", id: 19 },
    { name: "Bournemouth", code: "BOH", id: 20 },
    { name: "Inverness", code: "INV", id: 21 },
    { name: "Guernsey", code: "GCI", id: 22 },
    { name: "Southampton", code: "SOU", id: 23 },
    { name: "Isle of Man", code: "IOM", id: 24 },
    { name: "Glasgow Prestwick", code: "PIK", id: 25 },
    { name: "Exeter", code: "EXT", id: 26 },
    { name: "Norwich", code: "NWI", id: 27 },
    { name: "Sumburgh", code: "LSI", id: 28 },
    { name: "Newquay", code: "NQY", id: 39 },
    { name: "Teesside", code: "MME", id: 30 },
    { name: "City of Derry", code: "LDY", id: 31 },
    { name: "Kirkwall", code: "KOI", id: 32 },
    { name: "Stornoway", code: "SYY", id: 32 },
    { name: "Humberside", code: "HUY", id: 34 },
    { name: "London Southend", code: "SEN", id: 35 },
    { name: "Alderney", code: "ACI", id: 36 },
    { name: "Dundee", code: "DND", id: 37 },
    { name: "Benbecula", code: "BEB", id: 38 },
    { name: "Westray", code: "WRY", id: 39 },
    { name: "Papa Westray", code: "PPW", id: 40 },
    { name: "North Ronaldsay", code: "NRL", id: 41 },
    { name: "Stronsay", code: "SOY", id: 42 },
    { name: "Sanday", code: "NDY", id: 43 },
    { name: "Eday", code: "EOI", id: 44 },
  ];
  